export default [
    {
        title: '合同模板管理',
        path: '/ontractTemplate',
        name: 'ontractTemplate',
        meta: {
            key: 'ontractTemplate'
        },
        permission: 'ontractTemplate',
        menu: true,
        children: [
            {
                title: '通用模板管理',
                path: '/contractTemplate/normal',
                name: 'contractTemplateNormal',
                component: () => import('@/views/contractTemplate/normal/index'),
                meta: {
                    key: 'contractTemplateNormal',
                    open: 'ontractTemplate'
                },
                permission: 'contractTemplateNormal',
            },
            {
                title: '特殊条款管理',
                path: '/contractTemplate/special',
                name: 'contractTemplateSpecial',
                component: () => import('@/views/contractTemplate/special/index'),
                meta: {
                    key: 'contractTemplateSpecial',
                    open: 'ontractTemplate'
                },
                permission: 'contractTemplateNormal',
            },
            {
                title: '类目模板配置',
                path: '/contractTemplate/category',
                name: 'contractTemplateCategory',
                component: () => import('@/views/contractTemplate/category/index'),
                meta: {
                    key: 'contractTemplateCategory',
                    open: 'ontractTemplate'
                },
                permission: 'contractTemplateNormal',
            },
        ]
    },
    {
        title: '编辑合同模板',
        path: '/contractTemplate/normal/form',
        name: 'systemContractTemplateForm',
        component: () => import('@/views/contractTemplate/normal/form'),
        meta: {
            key: 'contractTemplateNormal',
            open: 'ontractTemplate'
        },
        permission: false,
        menu: false
    },
    {
        title: '合同模板详情',
        path: '/contractTemplate/normal/detail',
        name: 'contractTemplateNormalDetail',
        component: () => import('@/views/contractTemplate/normal/detail'),
        meta: {
            key: 'contractTemplateNormal',
            open: 'ontractTemplate'
        },
        permission: false,
        menu: false
    },
    {
        title: '合同模板预览',
        path: '/contractTemplate/normal/preview',
        name: 'contractTemplateNormalPreview',
        component: () => import('@/views/contractTemplate/normal/preview'),
        meta: {
            key: 'contractTemplateNormal',
            open: 'ontractTemplate'
        },
        permission: false,
        menu: false
    }
];
